import { ErrorDialogContext } from '../../../../../../components/ErrorDialog';
import { Routes } from '../../../../../../constants/Routes';
import { URLSearchParamsMonad } from '../../../../../../domains/base/SearchParams';
import { useContext } from '../../../../../../hooks/useContext';
import { useReservationId } from '../../../../../../hooks/useReservationId';
import { useTransaction } from '../../../../../../hooks/useTransaction';
import { SessionStore } from '../../../../../../stores/SessionStore';
import { ReservationTemporallyStore } from '../stores/ReservationTemporallyStore';

export const useActions = (store: ReservationTemporallyStore, session: SessionStore, currentURL: URL) => {
  const { reservationId, push, encode } = useReservationId();
  const { setError } = useContext(ErrorDialogContext);
  const handleError = (message: string) => {
    setError({
      header: '予約に失敗しました',
      message,
      onOk: () => {
        session.logout('/');
        setError();
      },
    });
  };

  const [load, loadStatus] = useTransaction(
    () =>
      store.fetch(reservationId).then(() => {
        if (store.fixable) {
          doFix();
        }
      }),
    e => {
      handleError(e.message);
    },
  );

  const [doFix, fixStatus] = useTransaction(
    () =>
      store.fix().then(res => {
        if (!res) return;
        const gclid = new URLSearchParams(currentURL.search).get('gclid');
        const params = new URLSearchParamsMonad(currentURL.search)
          .acceptOptional('reservationId', encode(res))
          .acceptOptional('gclid', gclid ?? undefined)
          .toString();
        push(`${Routes.Paths.ReservationSuccess}?${params}`, res);
      }),
    e => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const gqlError: { errors?: { message: string }[] } = e as any;
      handleError(gqlError.errors?.[0]?.message || e.message);
    },
  );

  return {
    doFix,
    fixStatus,
    load,
    loadStatus,
  };
};
